import { PassportStatus, PassportsList } from '@/typings/api/PassportList'
import { dateFormatter } from '@/helpers/dateFormatter'
import { PASSPORT_DOWNLOAD } from '@/views//PassportsList/table-actions'
import { createView } from '@/helpers/enums/table-actions'
import { PASSPORTS_LIST_ROUTES as ROUTES } from './utils'
import { Location } from 'vue-router'

const getViewRoute = (data: PassportsList): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createView<PassportsList>(getViewRoute),
  PASSPORT_DOWNLOAD,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: false,
    width: '90px',
  },
  {
    text: 'Логин',
    value: 'login',
    sortable: false,
  },
  {
    text: 'Наименование',
    value: 'ate_name',
    sortable: false,
  },
  {
    text: 'Статус',
    value: 'status',
    sortable: false,
    field: (v: PassportsList['status']) => {
      switch (v) {
        case PassportStatus.notStarted:
          return 'Не приступал'
        case PassportStatus.inProgress:
          return 'В работе'
        case PassportStatus.submitted:
          return 'Сдано'
        default:
          return ''
      }
    },
  },
  {
    text: 'Дата обновления',
    value: 'updated_at',
    sortable: true,
    width: 144,
    field: (value: PassportsList['updated_at']) => (
      (value && dateFormatter(value)) || '-'
    ),
  },
  {
    value: 'isActive',
    sortable: false,
  },
])
